<div class="content-wrapper p-0" [dir]="direction">
  <router-outlet></router-outlet>
</div>

